import { render, staticRenderFns } from "./ManiereApprendre.vue?vue&type=template&id=5ca61104&scoped=true"
import script from "./ManiereApprendre.vue?vue&type=script&lang=js"
export * from "./ManiereApprendre.vue?vue&type=script&lang=js"
import style0 from "./ManiereApprendre.vue?vue&type=style&index=0&id=5ca61104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca61104",
  null
  
)

export default component.exports